// Hero Slider with Swiper
document.addEventListener('DOMContentLoaded', function() {
  if (typeof Swiper !== 'undefined') {
    const heroSwiper = new Swiper('.hero-swiper', {
      loop: true,
      speed: 800,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: '.slider-dots',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },
      navigation: {
        nextEl: '.hero-next',
        prevEl: '.hero-prev',
      },
    });
  }

  // Category Slider with Swiper
  if (typeof Swiper !== 'undefined') {
    const categorySwiper = new Swiper('.category-swiper', {
      slidesPerView: 7,
      slidesPerGroup: 1,
      spaceBetween: 16,
      grabCursor: true,
      watchOverflow: true,
      navigation: {
        nextEl: '.category-next',
        prevEl: '.category-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 3.2,
          slidesPerGroup: 1,
          spaceBetween: 12,
        },
        480: {
          slidesPerView: 3.2,
          slidesPerGroup: 1,
          spaceBetween: 14,
        },
        768: {
          slidesPerView: 4.5,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },  
        1024: {
          slidesPerView: 6,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        1280: {
          slidesPerView: 8,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
      }
    });
  }

  // Video Testimonials Swiper
  if (typeof Swiper !== 'undefined') {
    const videoSwiper = new Swiper('.video-swiper', {
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: 4,
      spaceBetween: 20,
      loop: true,
      speed: 600,
      navigation: {
        nextEl: '.video-swiper .swiper-button-next',
        prevEl: '.video-swiper .swiper-button-prev',
      },
      breakpoints: {
        200: {
          slidesPerView: 2,
          spaceBetween: 18,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1240: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
      on: {
        init: function () {
          // Play video in initial active slide
          setTimeout(() => {
            const activeSlide = this.slides[this.activeIndex];
            const activeVideo = activeSlide?.querySelector('.video-wrapper video');
            if (activeVideo) {
              activeVideo.play().catch(e => console.log('Video autoplay prevented'));
            }
          }, 500);
        },
        slideChangeTransitionStart: function () {
          // Pause all videos
          const videos = document.querySelectorAll('.video-wrapper video');
          videos.forEach(video => {
            video.pause();
            video.currentTime = 0;
          });
        },
        slideChangeTransitionEnd: function () {
          // Play video in active slide
          const activeSlide = this.slides[this.activeIndex];
          const activeVideo = activeSlide?.querySelector('.video-wrapper video');
          if (activeVideo) {
            activeVideo.play().catch(e => console.log('Video autoplay prevented'));
          }
        },
      },
    });
  }

  // Banner Carousel Swiper
  if (typeof Swiper !== 'undefined') {
    const bannerSwiper = new Swiper('.banner-swiper', {
      slidesPerView: 3,
      slidesPerGroup: 1,
      spaceBetween: 20,
      grabCursor: true,
      watchOverflow: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: '.banner-next',
        prevEl: '.banner-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 18,
        },
        1024: {
          slidesPerView: 3,
          slidesPerGroup: 1,
          spaceBetween: 20,
        }
      }
    });
  }

  // Products Carousel Swipers - Initialize each section separately
  if (typeof Swiper !== 'undefined') {
    // Common swiper config for product carousels
    const productSwiperConfig = {
      slidesPerView: 4,
      slidesPerGroup: 1,
      spaceBetween: 24,
      grabCursor: true,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        320: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
          spaceBetween: 12,
        },
        640: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 3.5,
          slidesPerGroup: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          slidesPerGroup: 1,
          spaceBetween: 24,
        }
      }
    };

    // Initialize all product swipers with their respective navigation
    document.querySelectorAll('.products-swiper-container').forEach(function(container) {
      const swiperEl = container.querySelector('.products-swiper');
      const prevBtn = container.querySelector('.products-prev');
      const nextBtn = container.querySelector('.products-next');

      if (swiperEl) {
        new Swiper(swiperEl, {
          ...productSwiperConfig,
          navigation: {
            nextEl: nextBtn,
            prevEl: prevBtn,
          },
        });
      }
    });

    // Fallback: Initialize any standalone products-swiper without container
    document.querySelectorAll('.products-swiper').forEach(function(swiperEl) {
      if (!swiperEl.closest('.products-swiper-container') && !swiperEl.swiper) {
        new Swiper(swiperEl, productSwiperConfig);
      }
    });
  }

  // Customer Reviews Carousel with Infinite Loop
  const reviewCards = document.querySelectorAll('.review-card');
  const reviewNextBtn = document.querySelector('.review-next');
  const reviewPrevBtn = document.querySelector('.review-prev');
  
  if (reviewCards.length > 0 && reviewNextBtn) {
    let currentReviewIndex = 0;
    let isTransitioning = false;

    function showReview(index) {
      if (isTransitioning) return;
      isTransitioning = true;

      // Remove active and exiting classes from all cards
      reviewCards.forEach(card => {
        card.classList.remove('active', 'exiting');
      });

      // Add exiting class to current card
      if (reviewCards[currentReviewIndex]) {
        reviewCards[currentReviewIndex].classList.add('exiting');
      }

      // Update index with infinite loop
      currentReviewIndex = index % reviewCards.length;
      if (currentReviewIndex < 0) {
        currentReviewIndex = reviewCards.length - 1;
      }

      // Add active class to new card after a brief delay
      setTimeout(() => {
        reviewCards[currentReviewIndex].classList.add('active');
        setTimeout(() => {
          isTransitioning = false;
        }, 500);
      }, 50);
    }

    function nextReview() {
      showReview(currentReviewIndex + 1);
    }

    function prevReview() {
      showReview(currentReviewIndex - 1);
    }

    // Event listeners for navigation buttons
    reviewNextBtn.addEventListener('click', nextReview);
    
    if (reviewPrevBtn) {
      reviewPrevBtn.addEventListener('click', prevReview);
    }

    // Auto-advance reviews every 5 seconds
    let reviewInterval = setInterval(nextReview, 5000);

    // Pause auto-advance on hover
    const reviewsCarousel = document.querySelector('.reviews-carousel-wrapper');
    if (reviewsCarousel) {
      reviewsCarousel.addEventListener('mouseenter', () => {
        clearInterval(reviewInterval);
      });

      reviewsCarousel.addEventListener('mouseleave', () => {
        reviewInterval = setInterval(nextReview, 5000);
      });
    }

    // Initialize first card as active
    if (reviewCards[0]) {
      reviewCards[0].classList.add('active');
    }
  }

  // Weekly Monday Reset Countdown Timer
  function initCountdown() {
    const daysElement = document.querySelector('.countdown-number[data-unit="days"]') || document.querySelectorAll('.countdown-number')[0];
    const hoursElement = document.querySelector('.countdown-number[data-unit="hours"]') || document.querySelectorAll('.countdown-number')[1];
    const minsElement = document.querySelector('.countdown-number[data-unit="mins"]') || document.querySelectorAll('.countdown-number')[2];
    const secsElement = document.querySelector('.countdown-number[data-unit="secs"]') || document.querySelectorAll('.countdown-number')[3];

    if (!daysElement || !hoursElement || !minsElement || !secsElement) return;

    function getNextMonday() {
      const now = new Date();
      const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, 2 = Tuesday, etc.
      
      // Calculate days until next Monday
      let daysUntilMonday;
      if (currentDay === 0) {
        // Sunday - next Monday is 1 day away
        daysUntilMonday = 1;
      } else if (currentDay === 1) {
        // Monday - if it's past midnight, next Monday is 7 days away
        // If we want Monday to reset at midnight, we set it to 7 days
        daysUntilMonday = 7;
      } else {
        // Tuesday (2) to Saturday (6) - calculate days remaining
        daysUntilMonday = 8 - currentDay; // Example: Wednesday (3) = 8-3 = 5 days
      }
      
      // Create date object for next Monday at 00:00:00
      const nextMonday = new Date(now);
      nextMonday.setDate(now.getDate() + daysUntilMonday);
      nextMonday.setHours(0, 0, 0, 0);
      
      return nextMonday.getTime();
    }

    function updateCountdown() {
      const now = new Date().getTime();
      const targetDate = getNextMonday();
      const distance = targetDate - now;

      // If countdown is finished or negative, recalculate
      if (distance <= 0) {
        // This shouldn't happen with proper calculation, but just in case
        return updateCountdown();
      }

      // Calculate time units
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Update the DOM with padded values
      daysElement.textContent = String(days).padStart(2, '0');
      hoursElement.textContent = String(hours).padStart(2, '0');
      minsElement.textContent = String(minutes).padStart(2, '0');
      secsElement.textContent = String(seconds).padStart(2, '0');
    }

    // Update countdown immediately
    updateCountdown();

    // Update countdown every second
    setInterval(updateCountdown, 1000);
  }

  // Initialize countdown timer
  initCountdown();

  // Video Mute/Unmute Functionality - Using event delegation
  document.addEventListener('click', function(e) {
    // Check if click is on button or icon inside button
    const clickedElement = e.target;
    const muteButton = clickedElement.classList.contains('video-mute-btn') 
      ? clickedElement 
      : clickedElement.closest('.video-mute-btn');
    
    if (muteButton) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // Stop other listeners on this event
      
      const videoWrapper = muteButton.closest('.video-wrapper');
      if (!videoWrapper) {
        return;
      }
      
      const video = videoWrapper.querySelector('video');
      if (!video) {
        return;
      }
      
      const icon = muteButton.querySelector('i');
            
      if (video.muted) {
        // Unmute the video
        video.muted = false;
        icon.classList.remove('fa-volume-mute');
        icon.classList.add('fa-volume-up');
        muteButton.classList.add('unmuted');
        muteButton.setAttribute('aria-label', 'Mute video');
        console.log('Video unmuted');
      } else {
        // Mute the video
        video.muted = true;
        icon.classList.remove('fa-volume-up');
        icon.classList.add('fa-volume-mute');
        muteButton.classList.remove('unmuted');
        muteButton.setAttribute('aria-label', 'Unmute video');
        console.log('Video muted');
      }
      
      return false; // Prevent any further event handling
    }
  }, true); // Use capture phase

  // Initialize reviewer avatars with initials
  initializeReviewerAvatars();
});

// Function to generate initials from reviewer names
function initializeReviewerAvatars() {
  const reviewCards = document.querySelectorAll('.review-card');
  
  reviewCards.forEach(card => {
    const reviewerName = card.querySelector('.reviewer-info strong');
    const avatarDiv = card.querySelector('.reviewer-avatar');
    
    if (reviewerName && avatarDiv && !avatarDiv.hasAttribute('data-initialized')) {
      const name = reviewerName.textContent.trim();
      const initials = getInitials(name);
      
      // Set the initials if not already set
      if (!avatarDiv.textContent.trim()) {
        avatarDiv.textContent = initials;
      }
      
      avatarDiv.setAttribute('data-initialized', 'true');
    }
  });
}

// Helper function to extract initials from full name
function getInitials(name) {
  const parts = name.split(' ').filter(part => part.length > 0);
  
  if (parts.length === 0) return '??';
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  
  // Get first letter of first name and first letter of last name
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
